(function() {
  'use strict';

  const DISMISS_KEY = 'noetic_sub_upsell_dismissed';

  function getDismissed() {
    try {
      return JSON.parse(sessionStorage.getItem(DISMISS_KEY) || '[]');
    } catch(e) { return []; }
  }

  function setDismissed(handle) {
    const list = getDismissed();
    if (!list.includes(handle)) {
      list.push(handle);
      sessionStorage.setItem(DISMISS_KEY, JSON.stringify(list));
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initUpsells() {
    const upsells = document.querySelectorAll('.subscription-upsell');
    if (!upsells.length) return;

    const dismissed = getDismissed();

    upsells.forEach(function(el) {
      const handle = el.dataset.productHandle;
      const lineKey = el.dataset.lineItemKey;
      const linePrice = parseInt(el.dataset.linePrice) || 0;

      if (!handle || dismissed.includes(handle)) return;
      if (el.dataset.initialized) return;
      el.dataset.initialized = 'true';

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          if (!product.selling_plan_groups || !product.selling_plan_groups.length) return;

          var spg = product.selling_plan_groups[0];
          var plans = spg.selling_plans;
          if (!plans || !plans.length) return;

          var recurringPct = 11;
          if (plans[0].price_adjustments && plans[0].price_adjustments.length) {
            var adj = plans[0].price_adjustments[0];
            if (adj.value_type === 'percentage') recurringPct = adj.value;
          }

          // Read promo settings from global config (set by product page or cart drawer)
          var promo = window.__noeticSubPromo || { enabled: false, pct: 50, cartMsg: '' };
          var recurringSavings = Math.round(linePrice * recurringPct / 100);

          var msgHtml = '';
          if (promo.enabled && promo.cartMsg) {
            msgHtml = '<p class="sub-upsell-card__msg" style="color:#fdb142;font-weight:700;">' + promo.cartMsg + '</p>';
          } else if (promo.enabled) {
            msgHtml = '<p class="sub-upsell-card__msg" style="color:#fdb142;font-weight:700;">🎉 First 25 subscribers get ' + promo.pct + '% off their first order!</p>' +
              '<p class="sub-upsell-card__msg">Then save <strong>' + recurringPct + '%</strong> on every delivery. Save ' + formatMoney(recurringSavings) + ' per order.</p>';
          } else {
            msgHtml = '<p class="sub-upsell-card__msg">Subscribe & Save <strong>' + recurringPct + '%</strong> on every delivery! Save ' + formatMoney(recurringSavings) + '</p>';
          }

          var html = '<div class="sub-upsell-card">' +
            '<button class="sub-upsell-card__dismiss" aria-label="Dismiss">&times;</button>' +
            '<div class="sub-upsell-card__content">' +
              '<div class="sub-upsell-card__text">' +
                '<span class="sub-upsell-card__badge">☕ Mindful Explorer Experience</span>' +
                msgHtml +
              '</div>' +
              '<div class="sub-upsell-card__freq-pills">';

          plans.forEach(function(plan, i) {
            var name = plan.name.toLowerCase();
            var label;
            if (name.indexOf('2 week') !== -1) label = '2 Weeks';
            else if (name.indexOf('4 week') !== -1 || name.indexOf('1 month') !== -1) label = '4 Weeks';
            else if (name.indexOf('8 week') !== -1 || name.indexOf('2 month') !== -1) label = '8 Weeks';
            else label = plan.name.replace(/Delivery every /i, '').replace(/delivery every /i, '');
            html += '<button type="button" class="sub-upsell-card__freq-pill' + (i === 0 ? ' is-active' : '') + '" data-plan-id="' + plan.id + '">' + label + '</button>';
          });

          html += '</div>' +
                '<button class="sub-upsell-card__cta">Switch to Subscription</button>' +
            '</div>' +
          '</div>';

          el.innerHTML = html;

          // Dismiss handler
          el.querySelector('.sub-upsell-card__dismiss').addEventListener('click', function() {
            setDismissed(handle);
            el.style.opacity = '0';
            el.style.transform = 'translateY(-4px)';
            setTimeout(function() { el.remove(); }, 200);
          });

          // Frequency pill selection
          el.querySelectorAll('.sub-upsell-card__freq-pill').forEach(function(pill) {
            pill.addEventListener('click', function() {
              el.querySelectorAll('.sub-upsell-card__freq-pill').forEach(function(p) { p.classList.remove('is-active'); });
              pill.classList.add('is-active');
            });
          });

          // Switch to subscription handler
          el.querySelector('.sub-upsell-card__cta').addEventListener('click', function() {
            var btn = this;
            var activePill = el.querySelector('.sub-upsell-card__freq-pill.is-active');
            var planId = activePill ? activePill.dataset.planId : '';
            btn.textContent = 'Switching...';
            btn.disabled = true;

            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: lineKey,
                selling_plan: parseInt(planId)
              })
            })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              // Refresh cart drawer inline (avoid page reload that closes drawer)
              var isDrawer = !!el.closest('.cartDrawer');
              if (isDrawer) {
                // Fetch fresh cart HTML and update drawer body + footer
                fetch('/cart')
                  .then(function(r) { return r.text(); })
                  .then(function(html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    var freshBody = doc.querySelector('.mini-cart-has-item');
                    var freshFooter = doc.querySelector('#webi-main-cart-footer');
                    if (freshBody) {
                      var target = document.querySelector('.mini-cart-has-item');
                      if (target) target.innerHTML = freshBody.innerHTML;
                    }
                    if (freshFooter) {
                      var footerTarget = document.getElementById('webi-main-cart-footer');
                      if (footerTarget) footerTarget.innerHTML = freshFooter.innerHTML;
                    }
                    // Update cart count
                    var countEls = document.querySelectorAll('.cart-count-bubble span, .minicart-count');
                    countEls.forEach(function(span) {
                      span.textContent = cart.item_count;
                    });
                  });
              } else {
                // On the cart page, reload to refresh Liquid-rendered content
                window.location.reload();
              }
            })
            .catch(function() {
              btn.textContent = 'Switch to Subscription';
              btn.disabled = false;
            });
          });
        })
        .catch(function() {});
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsells);
  } else {
    initUpsells();
  }

  // Re-run when cart drawer is opened or updated
  var cartObserver = new MutationObserver(function(mutations) {
    var shouldReinit = mutations.some(function(m) {
      return m.addedNodes.length > 0;
    });
    if (shouldReinit) {
      setTimeout(initUpsells, 100);
    }
  });

  var cartDrawer = document.querySelector('.cartDrawer');
  if (cartDrawer) {
    cartObserver.observe(cartDrawer, { childList: true, subtree: true });
  }

  var cartItems = document.querySelector('#cart-items, .cart-items');
  if (cartItems) {
    cartObserver.observe(cartItems, { childList: true, subtree: true });
  }
})();
